<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<app-cookies-consent *ngIf="shouldShowCookiesConsent"></app-cookies-consent>
